import { AccordionContent, List, ListItem } from 'framework7-react';

interface ListItemPickerProps {
  pickerSelect: string;
  pickerInputID: string;
  pickerContainerID: string;
}
export const ListItemPicker = ({
  pickerSelect,
  pickerInputID,
  pickerContainerID,
}: ListItemPickerProps) => {
  return (
    <div className={'list-picker-field'}>
      <List accordionList noHairlines>
        <ListItem accordionItem title={pickerSelect} id={pickerInputID}>
          <AccordionContent>
            <div id={pickerContainerID} onClick={() => {}} />
          </AccordionContent>
        </ListItem>
      </List>
    </div>
  );
};
